module.exports = __webpack_public_path__ + "static/media/bencao-para-bebe.4f92f10a.png";